import { defaultNextHiddenProviderIndex, maxNumberOfProvidersToShow } from './constants'
import { FeedbackType, ProviderLevelFeedbackSavePayload } from './types'

export const getSelectedWordChipsAsJoinedString = (wordChips?: string[]) => {
  return wordChips?.join(';').toLowerCase() ?? ''
}

export const getTrimmedFreeTextFeedback = (freeTextFeedback?: string) => {
  return freeTextFeedback?.trim() ?? ''
}

export const generateProviderLevelFeedbackSavePayload = ({
  userId,
  providerId,
  searchId,
  requestId,
  feedbackType,
  wordChips = [],
  freeTextFeedback = '',
}: {
  userId: string
  providerId: string
  searchId: string
  requestId: string
  feedbackType: FeedbackType
  wordChips: string[]
  freeTextFeedback: string
}): ProviderLevelFeedbackSavePayload => {
  const wordChipsString = getSelectedWordChipsAsJoinedString(wordChips)
  const trimmedFreeTextFeedback = getTrimmedFreeTextFeedback(freeTextFeedback)

  return {
    userLyraId: userId,
    providerLyraId: providerId,
    searchId,
    requestId,
    feedbackType,
    wordChips: wordChipsString,
    freeTextFeedback: trimmedFreeTextFeedback,
  }
}

export const getInitialNextHiddenProviderIndex = ({ totalNumberOfProviders }: { totalNumberOfProviders: number }) => {
  return totalNumberOfProviders > maxNumberOfProvidersToShow
    ? maxNumberOfProvidersToShow
    : defaultNextHiddenProviderIndex
}
